import {
  Button,
  Input,
  Stack,
  Box,
  Flex,
  useBreakpointValue,
  Heading,
  Text,
  Card,
  Field,
  Icon,
  Checkbox,
} from "@chakra-ui/react";
import { userAccountLogin } from "helpers/backend_helper";
import { useNavigate } from "react-router";
import { FaFilePdf } from "react-icons/fa6";
import { useState } from "react";
import {
  PasswordInput,
  PasswordStrengthMeter,
} from "components/ui/password-input"
const LoginPage = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({ email: "", password: "", login: "" });
  const [form, setForm] = useState({ email: "", password: "" });
  const [rememberMe, setRememberMe] = useState(false);
  const isLargeScreen = useBreakpointValue({ base: false, lg: true });
  
  const handleLogin = async () => {
    const newErrors = {
      email: !form.email.trim(),
      password: !form.password.trim(),
      login: false,
    };
    setErrors(newErrors);
    if (newErrors.email || newErrors.password) return;

    try {
      const response = await userAccountLogin({...form, remember_me: rememberMe});
      const data= response.data;
      if (data.status === true) {
        localStorage.setItem("sessionToken", data?.token);
          if (rememberMe) {
        localStorage.setItem("sessionToken", data.token);
        localStorage.setItem("rememberMe", "true");
        sessionStorage.removeItem("sessionToken");
      } else {
        sessionStorage.setItem("sessionToken", data.token);
        localStorage.removeItem("sessionToken");
        localStorage.removeItem("rememberMe");
      }
        navigate(`/main/pdf-text-replacer`);
        setErrors({});
      } else {
        setErrors({ ...newErrors, login: true });
      }
    } catch (err) {
      console.error("Login error:", err);
      setErrors({});
    }
  };
  const handleFieldChange = (e) => {
    const { name, value } = e.target;

    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  return (
    <Box>
      {isLargeScreen ? (
        <Flex direction="row">
          <Box
            flex="1"
            bgImage="url('/pexels-mohammad-danish-290641-891059.jpg')"
            bgSize="cover"
            bgPosition="center"
            borderRadius="2xl"
          />

          <Flex
            flex="1"
            align="center"
            justify="center"
            minH="100vh"
            maxH="100vh"
          >
            <Box w="50%">
              <Flex direction="column" gap={5}>
                <Stack>
                  <Flex align="center" justify="space-between">
                    <Heading size="3xl" fontWeight="bold">
                      Log in
                    </Heading>
                    <Icon size="2xl" color="tomato">
                      <FaFilePdf />
                    </Icon>
                  </Flex>
                  <Text color="gray.400" fontSize="sm">
                    Fill in the form below to log in
                  </Text>
                </Stack>

                <Stack gap="4" w="full" mb="4">
                  <Field.Root>
                    <Field.Label>Email</Field.Label>
                    <Input
                      bg="gray.50"
                      borderColor={
                        errors.email || errors.login ? "red.300" : "gray.300"
                      }
                      value={form.email}
                      name="email"
                      onChange={(e) => handleFieldChange(e)}
                    />

                    {errors.email && (
                      <Text color="red.400" fontSize="xs">
                        Email is required
                      </Text>
                    )}
                  </Field.Root>
                  <Field.Root required>
                    <Field.Label>Password</Field.Label>
                  
                    <PasswordInput bg="gray.50"  borderColor={
                        errors.password || errors.login ? "red.300" : "gray.300"
                      } value={form.password} name="password"  onChange={(e) => handleFieldChange(e)}/>
                    {errors.password && (
                      <Text color="red.400" fontSize="xs">
                        Password is required
                      </Text>
                    )}
                  </Field.Root>

                  <Checkbox.Root
                    size="md"
                    colorPalette="orange"
                    variant="solid"
                    checked={rememberMe}
                    onCheckedChange={(e) => setRememberMe(e.checked)}   // <-- IMPORTANT
                  >
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>Remember me</Checkbox.Label>
                  </Checkbox.Root>

                </Stack>
                <Stack gap="1">
                  {errors.login && (
                    <Text color="red.400" fontSize="sm">
                      That email and password combination is incorrect.
                    </Text>
                  )}
                  <Button
                    variant="solid"
                    onClick={handleLogin}
                    _hover={{
                      transform: "scale(1.02)",
                      boxShadow: "md",
                    }}
                    transition="all 0.2s ease-in-out"
                  >
                    Log in
                  </Button>
                </Stack>
              </Flex>
            </Box>
          </Flex>
        </Flex>
      ) : (
        <Box
          minH="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgImage="url('/pexels-mohammad-danish-290641-891059.jpg')"
          bgSize="cover"
          bgPosition="center"
          bgRepeat="no-repeat"
        >
          <Card.Root
            variant="elevated"
            width={"md"} // ✅
          >
            <Card.Header>
              <Flex align="center" justify="space-between">
                <Box>
                  <Card.Title>Log in</Card.Title>
                  <Card.Description>
                    Fill in the form below to log in
                  </Card.Description>
                </Box>
                <Icon size="2xl" color="tomato">
                  <FaFilePdf />
                </Icon>
              </Flex>
            </Card.Header>
            <Card.Body>
              <Stack gap="4" w="full">
                <Field.Root>
                  <Field.Label>Email</Field.Label>
                  <Input
                    bg="gray.50"
                    borderColor={
                      errors.email || errors.login ? "red.300" : "gray.300"
                    }
                    value={form.email}
                    name="email"
                    onChange={(e) => handleFieldChange(e)}
                  />

                  {errors.email && (
                    <Text color="red.400" fontSize="xs">
                      Email is required
                    </Text>
                  )}
                </Field.Root>
                <Field.Root>
                  <Field.Label>Password</Field.Label>
                  
                  <PasswordInput bg="gray.50"  borderColor={
                        errors.password || errors.login ? "red.300" : "gray.300"
                      } value={form.password} name="password"  onChange={(e) => handleFieldChange(e)}/>
                  {errors.password && (
                    <Text color="red.400" fontSize="xs">
                      Password is required
                    </Text>
                  )}
                </Field.Root>
                <Checkbox.Root
                  size="md"
                  colorPalette="orange"
                  variant="solid"
                  checked={rememberMe}
                  onCheckedChange={(e) => setRememberMe(e.checked)}   // <-- IMPORTANT
                >
                  <Checkbox.HiddenInput />
                  <Checkbox.Control />
                  <Checkbox.Label>Remember me</Checkbox.Label>
                </Checkbox.Root>

              </Stack>
            </Card.Body>
            <Card.Footer justifyContent="space-between">
              {errors.login && (
                <Text color="red.400" fontSize="sm">
                  That email and password combination is incorrect.
                </Text>
              )}
              <Button
                variant="solid"
                onClick={handleLogin}
                _hover={{
                  transform: "scale(1.02)",
                  boxShadow: "md",
                }}
                transition="all 0.2s ease-in-out"
              >
                Log in
              </Button>
            </Card.Footer>
          </Card.Root>
        </Box>
      )}
    </Box>
  );
};

export default LoginPage;
